import { getCreateDomain, getWorldsDomain } from '@/lib/configs'

export const extractRoomIdFromUrl = (url: string) => {
  if (!url) return '/'

  const worldsDomain = `https://${getWorldsDomain()}`
  const createDomain = `https://${getCreateDomain()}`

  if (!url.startsWith(worldsDomain) && !url.startsWith(createDomain)) {
    return url
  }

  return `/${url.split('/').pop()?.split('?')[0]}`
}
